interface termsConditionData {
  heading?: string;
  content?: string | React.ReactNode;
}
const tcPairs: [string, React.ReactNode][] = [
  [
    "Terms of Service",
    <>
      <p className="mb-1">
        The “Terms of Service” and “Privacy Policy” will govern our relationship
        and are a contract governed solely by Florida law. Defy Medical, LLC
        requires that all visitors and Users, and Patients to services,
        therapies, treatments, sites, apps, API’s, content, and communications
        of Defy Medical, LLC (our “Services” and “Content”) adhere to the
        following terms and conditions of use.
      </p>
      <p>
        By accessing and using the Services, you agree, on your own behalf and
        on behalf of any party that you represent or for which you access the
        Services, to be bound by and comply with the following terms and
        conditions of use (these “Terms”) and to comply with all applicable laws
        and regulations. If you do not agree to these Terms, you are not
        authorized to use or access the Services.
      </p>
    </>,
  ],
  [
    "Medical Emergencies",
    <>
      ELECTRONIC COMMUNICATION IS NOT APPROPRIATE FOR ALL HEALTH ISSUES,
      ESPECIALLY THOSE OF AN URGENT NATURE, AND DEFY MEDICAL, LLC SERVICES MAKES
      NO GUARANTEE OF ANY PARTICULAR RESPONSE TIME TO AN INQUIRY YOU MAY MAKE.
      ACCORDINGLY, IF YOU ARE EXPERIENCING A MEDICAL EMERGENCY, YOU SHOULD NOT
      RELY ON THESE SERVICES FOR ASSISTANCE, BUT SHOULD INSTEAD SEEK APPROPRIATE
      EMERGENCY MEDICAL ASSISTANCE.
    </>,
  ],
  [
    "Insurance",
    <>
      <p className="mb-1">
        Defy Medical, LLC does not accept insurance of any kind. You will be
        provided receipts for all Services purchased, but Defy Medical, LLC will
        not otherwise process or assist with claims, and will not contact any
        insurance company.
      </p>
      <p className="mb-1">
        Payment Methods and Charges/ Credit Card Authorization
      </p>
      <p className="mb-1">
        By using our Services, you authorize Defy Medical, LLC to charge credit
        card(s) or other payment methods that we allow you to save
        electronically to your account for agreed upon Services. Your payment
        method(s) will only be charged at the time of purchase with your
        permission or at intervals for agreed upon Services with your
        permission.
      </p>
      <p className="mb-1">
        Your payment methods will be saved to a secure vault that meets or
        exceeds payment industry security standards for the convenience of
        future transactions on your account.
      </p>
      <p className="mb-1">
        You agree to maintain a valid payment method on your account.
      </p>
      <p className="mb-1">
        Defy Medical, LLC may delay or withhold Services if payment is declined
        or if no payment method is available to charge on your account.
      </p>
      <p>
        All sales are final. A credit may be issued on a case by case basis.
        Products ordered from a compounding pharmacy cannot be returned for any
        reason.
      </p>
    </>,
  ],
  [
    "Credits and Refunds",
    <>
      Any errors resulting use of Services by Defy Medical, LLC, laboratories,
      pharmacies, or any third party may result in a credit saved to your
      account which may be used toward future purchases of Services.
    </>,
  ],

  [
    "Refund Policies and Limitations",
    <>
      <p className="mb-1">
        Refunds for qualifying consultations, unshipped medication, and other
        orders must be requested within 90 days of purchase. After that, refunds
        will not be provided in credit or to the applicable payment method.
      </p>
      <p className="mb-1">
        Credits are only redeemable through Defy Medical, LLC.
      </p>
      <p className="mb-1">Credits do not expire.</p>
      <p className="mb-1">Credits do not have any fees.</p>
      <p className="mb-1">Credits cannot be transferred.</p>
      <p className="mb-1">Credits have no monetary value.</p>
      <p className="mb-1">
        If you do not wish to purchase further Services, a refund back to the
        applicable payment method(s) may be issued in lieu of a credit.
      </p>
      <p>
        Appointments and Consultations are not eligible for a credit or refund
        solely because of the outcome, or because a prescription or treatment
        was not recommended or given.
      </p>
    </>,
  ],
  [
    "Lab Order Refunds",
    <>
      <p className="mb-1">
        Lab orders are not eligible for a credit or refund solely because of the
        results.
      </p>
      <p className="mb-1">
        Lab orders are valid for three (3) months from the date of purchase. If
        you do not use your lab order within this time period it expires, but
        can be renewed at no charge for an additional three (3) months if
        requested.
      </p>
      <p className="mb-1">
        Refunds are only permitted prior to submission of specimens for testing.
        Lab orders are not eligible for a credit or refund solely because of the
        results.
      </p>
      <p className="mb-1">
        Within ninety (90) days of purchase, a refund can be issued using the
        original payment method. After 90 days have passed, no full refund will
        be issued in credit or to the applicable payment method.
      </p>
      <p className="mb-1">
        Within ninety-one to one hundred eighty (91 to 180) days, a Defy Medical
        Store (DefyMedicalStore.com) credit will be issued upon request, minus a
        $25 processing fee. Credits do not expire.
      </p>
      <p>
        If you have an issue, please let us try to help you first. Email us at
        care@defymedical.com or call 813-445- 7432 before you decide to cancel.
        Often it’s a simple fix to get things up and running for you again –
        we’re here to help.
      </p>
    </>,
  ],
  [
    "Limitation of Liability",
    <>
      <p className="mb-1">
        As partial consideration for your access to our Services, you agree that
        in no event will Defy Medical, LLC, its medical advisers, officers,
        directors, employees or its contractors, suppliers, pharmacies, content-
        providers and other similar entities, representatives and agents of each
        of the foregoing (collectively, our “Contractors”), be liable to you,
        any party that you represent, or any third party for any losses or
        damages, alleged under any legal theory, arising out of or in connection
        with: (a) your use of, or reliance on, the Services or the Content; (b)
        our performance of or failure to perform our obligations in connection
        with these Terms; (c) the defamatory, offensive or illegal conduct of
        other users of the Services or of third parties; or (d) your purchase or
        use of any goods or services provided by third parties.
      </p>
      <p className="mb-1">
        Under no circumstances will Defy Medical, LLC or our Contractors be
        liable to you, any party that you represent, or any third party for any
        indirect, consequential, incidental, punitive, special, or similar
        damages or costs (including, but not limited to, lost profits or data,
        loss of goodwill, loss of or damage to property, loss of use, business
        interruption and claims of third parties) arising out of or in
        connection with these Terms or the use of the Services or Content, or
        the transmission of information to or from the Services over the
        Internet, even if we were advised, knew, or should have known of the
        possibility of such damages or costs. In a jurisdiction that does not
        allow the exclusion or limitation of liability for certain damages, the
        liability of Defy Medical, LLC and the Contractors will be limited in
        accordance with these Terms to the extent permitted by law.
      </p>
      <p>
        Without limiting any of the foregoing, if Defy Medical, LLC or any of
        the Contractors is found liable to you or to any third party as a result
        of any claims or other matters arising under or in connection with these
        Terms, the Services, the Content, or your use of the Services, the
        maximum liability for all such claims and other matters will not exceed
        $100 in any calendar year.
      </p>
    </>,
  ],
  [
    "Indemnification",
    <>
      You agree to defend and indemnify Defy Medical, LLC, and our officers,
      directors, employees, representatives and agents, against all claims,
      demands, suits or other proceedings and all resulting loss, damage,
      liability, cost and expense (including reasonable attorneys’ fees), made
      by any third party arising out of: (a) content, data, or information that
      you submit, post to, or transmit through the Services; (b) your access to
      and use of the Services, the Content, and other materials, products, and
      services available on or through the Services; (c) your violation of these
      Terms; (d) your violation of any rights of any third party; (e) your
      website; and (f) any unauthorized use of a username, password, PIN or
      account number. We reserve, and you grant to us, the right to assume the
      exclusive defense and control of any matter subject to indemnification by
      you.
    </>,
  ],
  [
    "Use of Trademarks and Service Marks",
    <>
      Except for any limited permission to use the trademarks or service marks
      as set forth in these Terms, you may not, without our express written
      permission, use any of Defy Medical, LLC trademarks or service marks for
      any other purpose.
    </>,
  ],
  [
    "Disclaimer",
    <>
      The use of the Services or Content by you is at your and sole risk.
      ACCORDINGLY, THE SERVICES AND THE CONTENT ARE PROVIDED “AS IS” AND “AS
      AVAILABLE,” WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
      INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT, AND ALL SUCH
      WARRANTIES ARE EXPRESSLY DISCLAIMED AND EXCLUDED, TO THE FULLEST EXTENT
      PERMITTED BY LAW. SPECIFICALLY, DEFY MEDICAL, LLC, ITS MEDICAL ADVISORS,
      SUPPLIERS, CONSULTANTS, OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES AND
      CONTENT-PROVIDERS DO NOT WARRANT THAT: (a) THE USE OF THIE SERVICES OR ANY
      THIRD PARTY WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE; (b) THAT THE USE
      OF THE SERVICES OR ANY SUCH THIRD PARTY WEBSITE WILL ALLOW YOU TO OBTAIN
      ANY PARTICULAR RESULTS WHATSOEVER; (c) THE CONTENT OR ANY INFORMATION,
      SERVICE OR MERCHANDISE PROVIDED THROUGH THE SERVICES OR ANY THIRD PARTY
      WEBSITE ARE OR WILL BE ACCURATE, CURRENT, COMPLETE, RELIABLE, OR OF ANY
      PARTICULAR VALUE OR QUALITY; (d) THAT ANY DEFECTS IN THE SERVICES OR IN
      THE CONTENT WILL BE CORRECTED; OR (e) THAT THE SERVICES AND THE CONTENT
      ARE FREE OF VIRUSES OR OTHER DISABLING DEVICES OR HARMFUL COMPONENTS.
    </>,
  ],
  [
    "Jurisdiction",
    <>
      These Terms will be construed and enforced in accordance with the laws of
      the State of Florida without regard to choose of law rules. Each of you
      and any party that you represent submits to personal jurisdiction in
      Florida, and any cause of action arising under these Terms or otherwise
      involving the Services or the Content will be brought exclusively in a
      court in Hillsborough County, Florida. Terms of Service Page 3 of 8
    </>,
  ],
  [
    "Waiver of Jury Trial",
    <>
      YOU HEREBY KNOWINGLY AND VOLUNTARILY WAIVE THE RIGHT TO A JURY TRIAL IN
      ANY ACTIONS, SUITS OR PROCEEDINGS ARISING OUT OF OR RELATING TO THESE
      TERMS AND THE MATTERS CONTEMPLATED HEREBY.
    </>,
  ],
  [
    "Sole Agreement",
    <>
      These Terms and the Privacy Policy, each of which may be revised and
      amended from time to time according to their respective terms represent
      the sole agreement for general use of and access to Services and Content.
      Specific Services or Content may include additional and separate
      requirements, terms, and agreements.
    </>,
  ],
  [
    "Entire Agreement",
    <>
      These Terms and the Privacy Policy, each of which may be revised and
      amended from time to time according to their respective terms represent
      the entire agreement with respect to your access to and use of the
      Services and Content. Specific Services or Content may include additional
      and separate requirements, terms, and agreements.
    </>,
  ],
  [
    "Assignment",
    <>
      These Terms do not confer any rights, remedies, or benefits upon any
      person, entity, or third party other than you. We may assign our rights
      and duties under these Terms at any time to any third party without
      notice. You may not assign or transfer these Terms without prior written
      consent from Defy Medical.
    </>,
  ],
  [
    "Severability",
    <>
      If any portion of these Terms which may include a term, clause, or
      provision is found or held to be invalid or unenforceable, that term,
      clause, or provision will be stricken and will not affect the validity or
      enforceability of any remaining Terms. Our waiver of any breach of any
      term, clause, or provision of these Terms will not be a waiver of any
      preceding or subsequent breach thereof.
    </>,
  ],
  [
    "Termination",
    <>
      <p className="mb-1">
        Discontinuation of use of the Services and the Content is your sole
        right and remedy for any dissatisfaction with the Services or the
        Content.
      </p>
      <p>
        Defy Medical may terminate use of or access to Services or Content at
        any time and for any reason with or without notice.
      </p>
    </>,
  ],
  [
    "Survival",
    <>
      Any terms, clauses, or provisions of these Terms that are reasonably
      inferable to have been intended to survive termination (including, but not
      limited to: limitation of our liability, indemnification, disclaimer, or
      use of trademarks) will continue in effect beyond any such termination or
      access to the Services and Content either indefinitely or to the maximum
      extent allowed by law.
    </>,
  ],
  [
    "No Joint Venture",
    <>
      Accepting these Terms and the access or use of any Services or Content
      does not constitute any partnership or joint venture between any parties
      and Defy Medical.
    </>,
  ],
  [
    "Changes to Terms",
    <>
      We may make changes, to these Terms at any time with or without notice. We
      will make a best effort attempt to notify patients of changes to these
      Terms or the Privacy Policy as required by law.
    </>,
  ],
  [
    "Miscellaneous",
    <>
      <p className="mb-1">
        Our electronically or otherwise properly stored copy of these Terms will
        be deemed to be the true, complete, current, valid, authentic, and
        enforceable copy, and you agree that you will not contest the
        admissibility or enforceability of our copy of these Terms in connection
        with any action or proceeding arising out of or relating to these Terms.
      </p>
      <p className="mb-1">
        Possible evidence of activity or use of the Services for illegal
        purposes will be provided to law enforcement authorities.
      </p>
      <p>
        Any call made to or received from Defy Medical is subject to recording
        for training, quality assurance purposes, or operation of Services and
        Content.
      </p>
    </>,
  ],
  [
    "Medication Management",
    <>
      <p className="mb-1">
        This agreement between the patient, Dr Saya and Defy Medical establishes
        guidelines and conditions required for the use of hormone replacement
        therapy (HRT) and general primary care involving DEA controlled or
        scheduled medications. Dr. Saya and the patient agrees that these
        guidelines and conditions are an essential factor in maintaining a
        successful patient/practitioner relationship. Adverse side effects
        and/or physical/psychological dependence may develop after repeated use
        of these medications and therefore, are prescribed with caution.
      </p>
      <p className="mb-1">
        The patient accepts and agrees to the following conditions:
      </p>

      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 marker:text-black text-gray-600">
        <li>
          I understand that the medication(s) I have purchased are prescribed
          for me based on diagnosis derived from my submitted medical history,
          lab work, and physical exam. They are to be based exclusively for
          treatment of these diagnoses.
        </li>
        <li>
          I will immediately report any adverse side effects related to the use
          of my medication to Defy Medical and discontinue use until advised to
          resume usage.
        </li>
        <li>I will safeguard my medications from loss or theft.</li>
        <li>
          I will not share, sell or trade my medication for money, goods or
          services.
        </li>
        <li>
          I agree that I will use my medication at the prescribed rate and
          dosage and will keep the medications in its respected labeled
          container.
        </li>
        <li>
          I will not attempt to obtain scheduled HRT medications illegally or
          from any other health care practitioner without disclosing my current
          medication usage. I understand that it is against the law to do so.
        </li>
      </ul>
    </>,
  ],
  [
    "Clinical Procedures",
    <>
      <p className="mb-1">
        The number of patients we see is limited by appointment only. Missed
        appointments cause additional expense and inconvenience other patients.
        In-Office and Tele-med appointments that are cancelled less than 24
        hours in advance may be subject to pay the full cost of the consult fee.
        Patients who do not show up to their appointment (In-office or Tele-med)
        without prior notification will be subject to pay the full cost of the
        consult fee. All fees must be paid in full before the patient’s next
        appointment.
      </p>
      <p className="mb-1">
        Most health insurance companies typically do not provide coverage for
        medically monitored weight-loss and Bio-Identical Hormone Therapy.
        Therefore, we do not take any form of payment from third party companies
        and all services must be paid for at the time the services are rendered
        by cash, check or credit card.
      </p>
      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 marker:text-black text-gray-600">
        <li>
          I understand that if I choose to file a claim with a third-party
          insurance, Defy Medical will provide receipts of transaction but
          should not be expected to take further action.
        </li>
        <li>
          If my treatment includes prescription medications (hormones, appetite
          suppressants) I will carefully follow instructions given and notify
          the Practitioner of any change in my medical history (esp. for heart
          or blood pressure problems) and not resell the medication nor will I
          share it with any friend or family member, EVER. I will not visit
          other Practitioners for the purpose of obtaining additional or
          duplicate medication of the same type.
        </li>
        <li>
          I understand any treatments rendered through Defy Medical are solely
          for the purpose of hormone balancing/restoration, body-fat reduction,
          and preventative medicine. We are not capable of serving as your
          primary care facility. If I become ill, I should contact my personal
          Practitioner or visit an urgent care facility. If I become ill, I will
          discontinue any diet or weight loss medication from this clinic until
          it is determined safe to resume.
        </li>
        <li>
          I will consult my primary care Practitioner and/or endocrinologist to
          encourage and facilitate Practitioner communication regarding my
          treatments.
        </li>
        <li>
          I understand I will not be refunded for any lab orders or appointments
          once the service is provided, even if I do not qualify for any
          treatment.
        </li>
        <li>
          I understand I will not receive a refund for any medications or
          supplies once they are dispensed from the pharmacy. Once medications
          leave the pharmacy, they cannot be returned.
        </li>
        <li>
          I understand I will only receive a prescription when medically
          necessary and that I do not automatically qualify for Testosterone
          Therapy upon my initial assessment. Obtaining a prescription is always
          at the discretion of the Practitioner and is determined based on
          medical assessment and a diagnosis.
        </li>
        <li>
          I understand that all medication refill requests must first be
          reviewed and approved by the Practitioner. The patient MUST be in
          compliance with the practitioner’s treatment plan; including blood
          work, physical exams and consultations, in order to receive refills. A
          follow up appointment may be required prior to approving medication
          refills.
        </li>
        <li>
          I understand that restoring and balancing hormones accurately requires
          follow up blood work and monitoring. These follow ups may require
          additional cost for the patient. If I fail to complete requested
          follow-ups, I understand that my Practitioner at his/her discretion,
          will discontinue my therapy until requested follow-up is completed.
        </li>
        <li>
          I have been advised and do understand all the risks and possible
          complications of BHRT, as well as noncompliance with the
          Practitioner’s recommended dosage. I further agree to administer all
          medications as directed by the Practitioner.
        </li>
        <li>
          I agree to immediately report to the Practitioner any adverse
          reactions or problems, of whatever nature, whether said matters relate
          to BHRT treatment or not.
        </li>
        <li>
          I understand that if I am an out of state patient, I will provide
          current and updated Physical exams annually or as otherwise requested,
          to continue treatment.
        </li>
        <li>
          I understand that NO PRESCRIPTION WILL BE PROVIDED UNLESS A CLINICAL
          NEED EXISTS BASED ON REQUIRED LAB WORK, PRACTITIONER CONSULTATION,
          PHYSICAL EXAMINATION AND/OR CURRENT MEDICAL HISTORY. PLEASE NOTE,
          AGREEING TO LAB WORK AND PHYSICAL EXAM DOES NOT AUTOMATICALLY EQUATE
          TO CLINICAL NECESSITY AND A PRESCRIPTION.
        </li>
        <li>
          I request and consent to the administration of BHRT and /or
          nutritional supplements by the Practitioners of Defy Medical for the
          purpose of restoring optimal levels, even where lab test results are
          within reference ranges for age and/or in circumstances where other
          medical organizations do not recommend the same.
        </li>
        <li>
          MEN ONLY: I do not hold any medical practitioner of Defy Medical
          responsible for performing prostate cancer screening, PSA tests and/or
          rectal exams. I will consult with my primary care Practitioner or
          urologist about them and provide all appropriate medical records
          and/or facilitate inter-Practitioner communication regarding such
          evaluations. I understand a decision about treatment may depend on
          this information.
        </li>
      </ul>
    </>,
  ],
  [
    "Lab Orders for Required Lab Work",
    <>
      <p className="mb-1">
        Lab orders are valid for three (3) months from the date of purchase. If
        you do not use your lab order within this time period it expires, but
        can be renewed at no charge for an additional three (3) months if
        requested.
      </p>
      <p className="mb-1">
        Refunds are only permitted prior to submission of specimens for testing.
        Lab orders are not eligible for a credit or refund solely because of the
        results.
      </p>
      <p className="mb-1">
        Within ninety (90) days of purchase, a refund can be issued using the
        original payment method.
      </p>
      <p className="mb-1">
        Within ninety-one to one hundred eighty (91 to 180) days, a Defy Medical
        Store (DefyMedicalStore.com) credit will be issued upon request, minus a
        $25 processing fee. Credits do not expire.
      </p>
      <p>
        If you have an issue with your lab order, please let us try to help you
        first. Email us at care@defymedical.com or call 813-445-7342 before you
        decide to cancel. Often, it’s a simple fix to get things up and running
        for you again — we’re here to help.
      </p>
    </>,
  ],
  [
    "Required Hormone (HRT) Follow Up Evaluations",
    <>
      One of the purposes behind drawing blood for analysis is to provide our
      physician a means to compare how you are responding to therapy with your
      hormone blood levels and other important health indicators. This
      information allows our medical providers to make appropriate adjustments
      to your regimen that not only improve how you are feeling but minimize any
      side effects and risks with treatment. The laboratory analysis of your
      blood will also provide a comparison with initial blood work and provide
      data that will aid in the development of your treatment plan.
    </>,
  ],
  [
    "HRT Follow-up Blood Work",
    <>
      We strive to go beyond the minimum recommendations for monitoring every
      type of hormone replacement. All important tests needed to monitor men and
      women being prescribed hormones are completed at least twice per year and
      as needed based upon the individual’s response to treatment.
    </>,
  ],
  [
    "Pharmacy & Prescription Hormone Medication",
    <>
      <p className="mb-1">
        Defy Medical prescribes a variety of medications as appropriate for the
        patient. Our prescription management is included in the overall cost of
        care. We prescribe medications from pharmacies that meet high standards,
        follow USP and Good Manufacturing Practices, and utilize active ingredients.
      </p>

      <p className="mb-1">
        Defy Medical does not send prescriptions for controlled substances
        across state lines (i.e. fax or call in prescriptions for testosterone
        to retail pharmacies in other states). Controlled substances require
        additional steps to be taken by the doctor when prescribing to patients
        located in a different state. All forms of Testosterone are a controlled
        substance in every US state.
      </p>

      <p>
        Defy Medical prescribes a variety of medications as appropriate for the
        patient. Our prescription management is included in the overall cost of
        care. We prescribe medications from pharmacies that meet high standards,
        follow USP and Good Manufacturing Practices, and utilize active ingredients.
      </p>
    </>,
  ],
  [
    "Patient Compliance",
    <>
      <p className="mb-1">
        Patients have a responsibility to adhere to requirements and protocols
        to receive the most effective care. Defy Medical reserves the right to
        withhold Services to patients who do not or will not meet compliance
        requirements. The patient compliance requirements in these Terms may be
        changed, extended, or waived by the Medical Director under circumstances
        such as the COVID19 pandemic as a whole or on a case by case basis at
        their discretion.
      </p>
      <p className="mb-1">
        You agree to provide a valid, signed physical examination form for Defy
        Medical to include in your patient account at least once every 12 months
        or as documented by a Defy Medical provider in your treatment plan.
      </p>
      <p className="mb-1">
        You agree to consult with a Defy Medical provider at least once every 6
        months, or as documented by a Defy Medical provider in your treatment
        plan.
      </p>
      <p className="mb-1">
        You agree to have any necessary or required lab testing performed as
        required by Defy Medical at least once every 6 months or as documented
        by a Defy Medical provider in your treatment plan.
      </p>
      <p className="mb-1">
        You agree to refill and take any medications prescribed at the
        prescribed doses and frequencies as documented by a Defy Medical
        provider in your treatment plan.
      </p>
      <p className="mb-1">
        Consent and Authorization for Electronic Communication
      </p>
      <p className="mb-1">
        Email will be treated with the same level of privacy and confidentiality
        as written medical records.
      </p>
      <p className="mb-1">
        Authorized staff may read email sent by you and may send email to you as
        necessary for Services. Emails may be routed to another authorized
        person when appropriate or necessary.
      </p>
      <p className="mb-1">
        All non-marketing/newsletter emails sent from Defy Medical use current
        TLS encryption to secure the message so that it cannot be read by a
        third-party while being sent over networks including the internet. Many
        email providers such as Gmail and Office 365 now support automatic TLS
        encryption for every email that you send and receive. If your email
        provider does not support TLS encryption, then you will receive emails
        from Defy Medical containing a link to a secure portal to view and reply
        to messages.
      </p>
      <p className="mb-1">
        All emails sent to us are encrypted once they reach our service
        providers, servers, and systems. If your email provider does not support
        TLS encryption, then your message may not be secured and may be viewed
        by another party before it reaches our systems.
      </p>
      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 marker:text-black text-gray-600">
        <li>
          {" "}
          You agree to maintain a valid and correct email address on file.
        </li>
        <li>
          You agree not to use email communications for a medical emergency,
          crisis, or other health issue of an urgent nature.
        </li>
        <li>
          {" "}
          You agree that all emails sent to Defy Medical are addressed correctly
          and that they only contain the intended recipients. Defy Medical is
          not responsible for emails addressed incorrectly or for sending
          communications to an incorrect email address on file.
        </li>
        <li>
          You acknowledge and agree that you assume all responsibility and risk
          in the privacy and security of any email that is sent to Defy Medical
          from an email provider that does not support TLS encryption whether
          known or unknown to you or Defy Medical.
        </li>
        <li>
          You consent to sending and receiving non-secure electronic
          communications if there is no secure alternative option available
          using the same medium to communicate with you which may include non-
          secure email instead of TLS encrypted email.
        </li>
        <li>
          You acknowledge that copies of emails sent from you or emails sent to
          you may be archived as a part of your patient account or medical
          record.
        </li>
        <li>
          You agree to add care@defymedical.com and info@defymedical.com to your
          email provider’s approved / safe senders list. This will prevent
          important email from being incorrectly marked as spam or junk email
          because of attachments such as receipts, instructions, or lab results.
        </li>
        <li>
          You make revoke consent to communicate electronically by notifying
          Defy Medical in writing. Revoking consent will not have any effect on
          actions or communications that Defy Medical has already taken in
          reliance on your consent.
        </li>
      </ul>

      <p className="mt-1">
        If you have questions about electronic communication, please email <a href="mailto:care@defymedical.com"  className="text-[rgb(13,116,185)] underline">care@defymedical.com.</a>
      </p>
    </>,
  ],
];
export const termsConditionsData: termsConditionData[] = tcPairs.map(
  ([heading, content]) => ({
    heading,
    content,
  })
);
